import React, { useState, useEffect } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import { shopBg } from '../../../../assets/images';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPageContent } from '../../../../store/actions/ProductActions';
import { addItemToCart, removeCartItem } from '../../../../store/actions/CartActions';
import { toast } from 'react-toastify';
import { endpoint } from '../../../../config/config';
import _ from 'lodash';
import { Alert } from '@mui/material';
import moment from 'moment';
import { calculateExpectedDeliveryDate } from '../../../../utils/appFunctions';
import { appExtraFunctions } from '../../../../store/actions/AppActions';

const CartDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cartProducts = useSelector(state => state?.cart?.products);
  const token = useSelector(state => state?.auth?.token);

  useEffect(() => {
    if (token) {
      dispatch(getPageContent('getUserCartProducts', token));
    }
  }, []);

  const handleRemoveCartProduct = product => {
    dispatch(removeCartItem(product, token));
  };

  const getOrderSubTotal = () => {
    const total = cartProducts?.reduce((a, b) => a + b?.price * b?.quantity, 0);

    return total;
  };

  const handleUpdateQuantity = (product, value) => {
    const cartProduct = { ...product, quantity: value };
    dispatch(addItemToCart(cartProduct, token, false));
  };

  const handleCheckout = () => {
    // if (!token) {
    //   return toast.error('Please login to checkout.');
    // }
    dispatch(appExtraFunctions('saveActiveStep', 0));

    return navigate('/checkout');
  };

  return (
    <div>
      <AppTitle title='Cart' from='shop' link='/shop' to='Cart' bgImg={shopBg} />

      <div className='section section-padding-03'>
        <div className='container custom-container'>
          <div className='row mb-n30'>
            <div className='col-lg-8 col-12 mb-30'>
              <div className='table-responsive'>
                <table className='cart-table table text-center align-middle mb-6 d-none d-md-table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th className='title text-start'>Product</th>
                      <th className='price'>Price</th>
                      <th className='quantity'>Quantity</th>
                      <th className='total'>Subtotal</th>
                      <th className='total'>Delivered Date</th>
                    </tr>
                  </thead>
                  <tbody className='border-top-0'>
                    {_.sortBy(cartProducts, 'title')?.map((product, i) => (
                      <tr key={i}>
                        <th className='cart-remove'>
                          <button
                            className='remove-btn'
                            onClick={() => handleRemoveCartProduct(product)}
                          >
                            <i className='lastudioicon lastudioicon-e-remove'></i>
                          </button>
                        </th>
                        <th className='cart-thumb'>
                          <Link to={`/product/${product?._id}`}>
                            <img
                              src={`${product?.selectedImg ?? product?.files?.[0]?.path}`}
                              alt='Croissant Italy Cake'
                            />
                          </Link>
                        </th>
                        <th className='text-start'>
                          <Link to={`/product/${product?._id}`}>{product?.title}</Link>
                        </th>
                        <td>₹{product?.price.toFixed(2)}</td>
                        <td className='text-center cart-quantity'>
                          <div className='quantity' style={{ transform: 'scale(0.9)' }}>
                            <div className='cart-plus-minus'>
                              <div
                                className='dec qtybutton'
                                onClick={() =>
                                  product?.quantity > 1 &&
                                  handleUpdateQuantity(product, product?.quantity - 1)
                                }
                              >
                                -
                              </div>
                              <input
                                className='cart-plus-minus-box'
                                value={product?.quantity}
                                // onChange={handleQuantityChange}
                              />
                              <div
                                className='inc qtybutton'
                                onClick={() => handleUpdateQuantity(product, product?.quantity + 1)}
                              >
                                +
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>₹{(product?.price * product?.quantity).toFixed(2)}</td>
                        <td>{calculateExpectedDeliveryDate(product?.bufferingDays)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {cartProducts?.length === 0 && (
                <div>
                  <Alert sx={{ mb: 2 }} severity='success' color='warning'>
                    No products were found in the cart.
                  </Alert>
                </div>
              )}

              <div className='cart-products-mobile d-md-none'>
                {_.sortBy(cartProducts, 'title')?.map((product, i) => (
                  <div className='cart-product-mobile' key={i}>
                    <div className='cart-product-mobile-thumb'>
                      <Link to={`/product/${product?._id}`} className='cart-product-mobile-image'>
                        <img
                          src={`${product?.selectedImg ?? product?.files?.[0]?.path}`}
                          alt='Croissant Italy Cake'
                          width='90'
                          height='103'
                        />
                      </Link>
                      <button
                        className='cart-product-mobile-remove'
                        onClick={() => handleRemoveCartProduct(product)}
                      >
                        <i className='lastudioicon lastudioicon-e-remove'></i>
                      </button>
                    </div>
                    <div className='cart-product-mobile-content'>
                      <h5 className='cart-product-mobile-title'>
                        <Link to={`/product/${product?._id}`}>{product?.title}</Link>
                      </h5>
                      <span className='cart-product-mobile-quantity'>
                        {product?.quantity} x {product?.price}
                      </span>
                      <span className='cart-product-mobile-total'>
                        <b>Total:</b> ₹{product?.price * product?.quantity}
                      </span>
                      {product?.bufferingDays && (
                        <span className='cart-product-mobile-total'>
                          <b>Delivered By: </b>
                          {/* <>
                            {product?.bufferingTime?.[0]?.days &&
                              moment()
                                .add(product?.bufferingTime?.[0]?.days, 'days')
                                .format('DD/MM/YYYY')}

                            {product?.bufferingTime?.[0]?.hours && (
                              <> {product?.bufferingTime?.[0]?.hours}</>
                            )}
                          </> */}
                          {calculateExpectedDeliveryDate(product?.bufferingDays)}
                        </span>
                      )}
                      <div
                        className='quantity'
                        style={{ transform: 'scale(0.7) translateX(-20%)' }}
                      >
                        <div className='cart-plus-minus'>
                          <div
                            className='dec qtybutton'
                            onClick={() =>
                              product?.quantity > 1 &&
                              handleUpdateQuantity(product, product?.quantity - 1)
                            }
                          >
                            -
                          </div>
                          <input
                            className='cart-plus-minus-box'
                            value={product?.quantity}
                            // onChange={handleQuantityChange}
                          />
                          <div
                            className='inc qtybutton'
                            onClick={() => handleUpdateQuantity(product, product?.quantity + 1)}
                          >
                            +
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className='row justify-content-between gap-3'>
                <div className='col-auto'>
                  <button
                    className='btn btn-outline-dark btn-primary-hover rounded-0'
                    onClick={() => navigate('/shop')}
                  >
                    Continue Shopping
                  </button>
                </div>
                <div className='col-auto d-flex flex-wrap gap-3'>
                  {/* <button className='btn btn-outline-dark btn-primary-hover rounded-0'>
                    Update Cart
                  </button>
                  <button className='btn btn-outline-dark btn-primary-hover rounded-0'>
                    Clear Cart
                  </button> */}
                </div>
              </div>
            </div>

            <div className='col-lg-4 col-12 mb-30'>
              {cartProducts && cartProducts?.length > 0 && (
                <div className='cart-totals'>
                  <div className='cart-totals-inner'>
                    <h4 className='title'>Cart totals</h4>
                    <table className='table bg-transparent'>
                      <tbody>
                        {/* <tr className='subtotal'>
                        <th className='sub-title'>Subtotal</th>
                        <td className='amount'>
                          <span>£148.00</span>
                        </td>
                      </tr> */}
                        <tr className='total'>
                          <th className='sub-title'>Total</th>
                          <td className='amount'>
                            <strong>₹{getOrderSubTotal().toFixed(2)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <a
                    onClick={handleCheckout}
                    className='btn btn-dark btn-hover-primary rounded-0 w-100'
                  >
                    Proceed to checkout
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartDetails;
